/* ============================================================
   US-Parts24 · „Der Weg" — R487 / R500 / R501 / R503 / R508 / R509.

   Die Reise eines Teils als Startseiten-Scroll: VIN → US-Lager →
   Florida → Luftfracht → Leipzig → verbaut. Sechs Stationen auf EINER
   Bahn; dahinter läuft echtes Filmmaterial (Veo-3.1-Clips, keine
   Menschen, keine Logos) als Bildfolge, die der Scroll vor- und
   zurückspult (Einzelbilder auf Canvas — ein <video> lässt sich auf
   iOS nicht zuverlässig per currentTime spulen).

   ── R508: „ES LAGGT EINFACH UND HAKT ÜBEL" (Marcel, 18.09.) ─────
   Gemessen mit sofortigem Scrollen nach dem Laden (so wie ein echter
   Besucher, nicht erst nach 4 s Wartezeit — das war die Lücke in der
   R503-Messung): 4× gedrosselte CPU → 106 Takte über 50 ms, zusammen
   8,6 s Ruckeln, davon 2,7 s in DIESEM Skript. Die Ursachen:
     1. Alle 150 Bilder wurden als <img> geladen und sofort mit
        img.decode() entpackt — 150 × 3,7 MB entpackte Pixel.
     2. Jedes fertige Bild löste ein Neuzeichnen aus, auch wenn man
        noch oben im Hero war und den Film gar nicht sah.
   Jetzt:
     • Vorladen nur als komprimierte Datei (fetch → Blob), gedrosselt,
       mit niedriger Priorität, erst nach dem Laden der Seite.
     • Entpackt wird nur ein Fenster um die aktuelle Stelle, per
       createImageBitmap(blob) — das läuft abseits des Hauptfadens.
     • Gezeichnet (und überhaupt gerechnet) wird nur, wenn der Film im
       Bild ist.
     • Leichte Fassung automatisch: Stufe „mittel" der Leistungswache
       (usp-motion.js) ODER eigene Messung beim Spulen (zu viele lange
       Takte) → nur jedes 2. Bild, kleineres Fenster, keine Überblendung.
       Stufe „sparsam" → gar keine Folge, nur das Standbild.

   Bei Bewegungsreduzierung und im Theme-Editor startet das Modul nicht;
   dann steht die vollständige Stationsliste im HTML.
   ============================================================ */
(function () {
  'use strict';
  function messwert(n) { var w = window.__uspFilm || (window.__uspFilm = {}); return w[n] || (w[n] = { gemalt: 0, ersatz: 0 }); }

  var wurzeln = document.querySelectorAll('[data-usp-weg]');
  if (!wurzeln.length) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var inEditor = Boolean(window.Shopify && window.Shopify.designMode);
  if (reduce || inEditor) return; // Die Liste im HTML ist dann der Inhalt.

  var leerlauf = window.requestIdleCallback || function (f) { return setTimeout(f, 60); };

  Array.prototype.forEach.call(wurzeln, starten);

  function starten(wurzel) {
    var canvas = wurzel.querySelector('[data-usp-weg-canvas]');
    /* R512: deckend (alpha: false) — der Browser muss die Leinwand nicht mit
       dem Hintergrund verrechnen. Bis zum ersten Bild blendet CSS sie aus. */
    var ctx = canvas && canvas.getContext ? canvas.getContext('2d', { alpha: false }) : null;
    if (!ctx) return;

    var stationen = Array.prototype.slice.call(wurzel.querySelectorAll('[data-usp-weg-station]'));
    if (stationen.length < 2) return;

    var anzeigeNr = wurzel.querySelector('[data-usp-weg-nr]');
    var anzeigeGesamt = wurzel.querySelector('[data-usp-weg-gesamt]');
    var anzeigeKm = wurzel.querySelector('[data-usp-weg-km]');
    /* ⚠️ NICHT '[data-usp-weg-ort]' — das tragen auch die <article>-Stationen,
       und querySelector nimmt den ERSTEN Treffer (R487). */
    var anzeigeOrt = wurzel.querySelector('[data-usp-weg-ortanzeige]');
    /* R509 — die Karte (kleiner Globus): Route und Punkt folgen dem Flug */
    var kartenBogen = wurzel.querySelector('[data-usp-weg-bogen]');
    var kartenPunkt = wurzel.querySelector('[data-usp-weg-punkt]');
    var bogenLaenge = kartenBogen && kartenBogen.getTotalLength ? kartenBogen.getTotalLength() : 0;
    var flugZuletzt = -1;
    var rail = wurzel.querySelector('[data-usp-weg-rail]');
    var bahn = wurzel.querySelector('[data-usp-weg-bahn]');

    var GESAMT_KM = 7809;               // Orlando (MCO) → Leipzig (LEJ), Großkreis
    var N = stationen.length;
    if (anzeigeGesamt) anzeigeGesamt.textContent = String(N).padStart(2, '0');

    var marken = [];
    if (rail) {
      stationen.forEach(function (st, i) {
        var m = document.createElement('span');
        m.className = 'usp-weg__marke';
        m.style.left = (i / N) * 100 + '%';   // Beginn der Station
        m.setAttribute('aria-hidden', 'true');
        rail.appendChild(m);
        marken.push(m);
      });
    }

    /* ---------- Die Bildfolge ---------- */
    var mobil = window.matchMedia('(max-width: 749px)').matches;
    var satz = mobil ? 'm' : 'd';
    var anzahl = parseInt(wurzel.getAttribute('data-usp-weg-bilder-' + satz), 10) || 0;
    var muster = wurzel.getAttribute('data-usp-weg-url-' + satz) || '';
    var film = anzahl > 1 && muster.indexOf('000') !== -1 && 'createImageBitmap' in window;

    /* Fassung: „voll" oder „leicht" (jedes 2. Bild, kleines Fenster, keine Überblendung) */
    var leicht = false;
    var schritt = 1;
    var FENSTER = mobil ? 8 : 12;
    function leichtSchalten() {
      if (leicht) return;
      leicht = true;
      schritt = 2;
      FENSTER = mobil ? 4 : 6;
      wurzel.classList.add('is-leicht');
      aufraeumen(mitte);
      zuletzt = '';
    }

    function url(i) {
      /* asset_url liefert „…/usp-weg-d-000.webp?v=…" — Nummer tauschen. */
      return muster.replace('000', String(i).padStart(3, '0'));
    }

    /* ---------- 1. Vorladen: nur komprimiert, gedrosselt ---------- */
    var dateien = new Array(anzahl);    // Blob
    /* R510: was schon unterwegs ist, nicht ein zweites Mal holen (gemessen: 111 Abrufe für 108 Bilder) */
    var unterwegs = {};
    var ladeSchlange = [];
    var ladeLaufend = 0;
    /* R512: gemessen — mit Leerlauf-Pause nach JEDER Datei kamen beim Scrollen
       nur ~7 Bilder/s an (requestIdleCallback feuert beim Scrollen kaum); der
       Drohnenflug hatte bei Ankunft 39 von 144 Bildern. Jetzt: Pause nur, solange
       die Seite selbst noch lädt; danach so schnell, wie die Leitung hergibt. */
    var LADE_PARALLEL = mobil ? 3 : 4;
    var ENTPACK_PARALLEL = mobil ? 2 : 3;
    var seiteGeladen = document.readyState === 'complete';
    if (!seiteGeladen) window.addEventListener('load', function () { seiteGeladen = true; ladeNaechste(); }, { once: true });
    function weiterLaden() { ladeNaechste(); }
    /* Während die Seite noch lädt: nur 2 Downloads gleichzeitig statt Leerlauf-
       Pause — gemessen: wer sofort scrollte, fand die Bilder noch nicht vor. */
    function ladeGrenze() { return seiteGeladen ? LADE_PARALLEL : 2; }
    var geladenZahl = 0, fertigGemeldet = false;
    var vorladenGestartet = false;

    function ladeReihenfolge() {
      /* Erst der Anfang (dort betritt man den Film), dann grob → fein */
      var out = [], gesehen = {};
      for (var i = 0; i <= FENSTER && i < anzahl; i += schritt) { gesehen[i] = true; out.push(i); }
      [8, 4, 2, 1].forEach(function (s) {
        if (s < schritt) return;
        for (var j = 0; j < anzahl; j += s) if (!gesehen[j]) { gesehen[j] = true; out.push(j); }
      });
      return out;
    }

    function ladeNaechste() {
      while (ladeLaufend < ladeGrenze() && ladeSchlange.length) {
        var i = ladeSchlange.shift();
        if (dateien[i] || unterwegs[i] || (leicht && i % schritt)) continue;
        unterwegs[i] = true; ladeLaufend++;
        (function (i) {
          /* R510: Accept MUSS WebP nennen. Shopifys CDN wählt das Format nach
             dem Accept-Kopf (Vary: Accept); fetch() schickt „alles" und bekam
             ein umgerechnetes JPEG — gemessen 198 statt 81 KB je Bild, die
             ganze Folge 2,5-mal so schwer. */
          fetch(url(i), { priority: 'low', credentials: 'omit', headers: { Accept: 'image/webp,*/*;q=0.8' } })
            .then(function (r) { if (!r.ok) throw new Error(r.status); return r.blob(); })
            .then(function (b) {
              dateien[i] = b; delete unterwegs[i];
              ladeLaufend--; geladenZahl++;
              if ((sichtbar || vorEntpacken) && Math.abs(i - mitte) <= FENSTER) { karteAnfordern(i); }
              if (!fertigGemeldet && !ladeSchlange.length && !ladeLaufend) {
                /* Der Drohnenflug (usp-scrollfilm.js) wartet darauf, damit sich
                   beide Filme die Leitung nicht teilen. */
                fertigGemeldet = true;
                document.dispatchEvent(new CustomEvent('usp:film-geladen', { detail: 'weg' }));
              }
              weiterLaden();
            })
            .catch(function () { delete unterwegs[i]; ladeLaufend--; weiterLaden(); });
        })(i);
      }
    }

    /* ---------- Vorlade-Sperre: erst nach echtem Scrollweg ----------
       Gemessen am 22.09.2026 (R539) im Erstbesuch, sechs Sekunden gestanden,
       KEIN Scroll: 216 Bilder, 20,88 MB — 88 % der ganzen Seitenlast. Drei
       Wege riefen `vorladen()`, keiner verlangte eine Bewegung: der
       Vorlauf-Beobachter (200 % rootMargin greift schon beim Laden, wenn die
       Sektion nahe genug oben steht) und der Leerlauf nach `load`, der
       bedingungslos feuerte.

       Warum Strecke statt Ereignis: Lenis feuert ein scroll-EREIGNIS beim
       Start — ein Tor daran hatte sich in R512 nach 758 ms von selbst
       geoeffnet. Nur ein echter Weg zaehlt (siehe ereignis-ist-kein-nachweis).

       `sofort` umgeht die Sperre. Das ist kein Schlupfloch, sondern der
       Bedarfsfall: Wer den Film TATSAECHLICH im Bild hat (Sprungmarke,
       Neuladen mitten auf der Seite), braucht die Bilder jetzt. */
    var STRECKE = 250;
    var hatGescrollt = false;
    var vorladenAngefordert = false;
    var vorEntpacken = false;     /* 29.09.2026: Film nah oben → erstes Fenster schon vor „sichtbar“ entpacken */

    function standRoll() {
      return ziel === document
        ? (window.pageYOffset || document.documentElement.scrollTop || 0)
        : (ziel.scrollTop || 0);
    }
    function torAbmelden() {
      ziel.removeEventListener('scroll', beiBewegung);
      window.removeEventListener('scroll', beiBewegung);
    }
    /* Auch „die Sektion ist sichtbar" ist KEIN Freibrief fuers Vorladen.
       Gemessen am 22.09.: Am Rechner steht der Film auf der Startseite 58 px
       unter der Kante (der 10-%-Rand des Beobachters zaehlt ihn schon als
       sichtbar), auf der Weiterleitungsseite steht er sogar im Bild. Beide
       Male luden vorher alle 217 Bilder, bevor irgendjemand gescrollt hatte.

       Wer den Film im Bild hat, braucht das AKTUELLE Bild — nicht alle 217.
       Genau dafuer gibt es `dringend()`. Die volle Reihe wartet auf echten
       Scrollweg; bis dahin kommt Bild fuer Bild. */

    function beiBewegung() {
      if (hatGescrollt) return;
      if (standRoll() < STRECKE) return;      /* Startzucken zaehlt nicht */
      hatGescrollt = true;
      torAbmelden();
      if (vorladenAngefordert) vorladen(true);
    }

    function vorladen(sofort) {
      if (vorladenGestartet || !film) return;
      if (!sofort && !hatGescrollt) { vorladenAngefordert = true; return; }
      vorladenGestartet = true;
      ladeSchlange = ladeReihenfolge();
      ladeNaechste();
    }

    /* ---------- R542: Grobsatz VOR dem Tor ----------
       Marcel 23.09.2026: „Wenn man zum ersten Mal die Seite betritt, laggt es
       übel, bis die Bilder zum ersten Mal geladen haben."
       Gemessen (WebKit, Erstbesuch, sofort gescrollt): In den ersten 1.350 px
       Scrollweg malte der Film 7-mal, 5 davon mit Ersatzbild — das Tor öffnet
       erst NACH 250 px Bewegung, dann kommen 216 Bilder in ~2,8 s. Genau in
       diesem Fenster steht der Film und springt dann.
       Jetzt: kurz nach dem Aufbau jedes 8. Bild (Rechner 27 ≈ 2,2 MB,
       Handy 17) — über DENSELBEN Lader, kein zweiter Weg. Damit hat der Film ab
       dem ersten Millimeter ein Bild in höchstens 4 Schritten Abstand; die volle
       Reihe wartet weiter auf echten Scrollweg (R539 bleibt: ohne Scroll lädt
       die Seite nicht mehr als diesen Grobsatz). Kein Grobsatz im Datensparmodus. */
    var GROB = 8;
    var grobGestartet = false;
    function grobVorladen() {
      if (grobGestartet || vorladenGestartet || !film) return;
      if (/[?&]grob=0\b/.test(location.search)) return;   // Messschalter: Vergleich ohne Grobsatz
      /* Nicht am Handy. Die Entscheidung stimmt, die ZAHLEN dahinter waren erst
         falsch — nachgetragen am 23.09.2026:

         Der erste Vergleich lief mit einem Prüf-Browser, der sich als iOS 17
         ausgab. Shopifys CDN schickt dieser Kennung JPEG statt WebP (86 statt
         25 KB je Bild), also schleppte der Grobsatz am Handy 3,4-fache Last.
         Mit echter Kennung (iOS 18+) neu gemessen, 3 Läufe, gedrosselt:

           Handy  grob=1: 12,7 leere Takte · 1,00 MB im Stand
           Handy  grob=0: 13,3 leere Takte · 0,06 MB im Stand

         0,6 Takte für 0,94 MB — lohnt nicht. Am Rechner dagegen 5,0 → 3,0.

         Auch geprüft und ohne Wirkung: LADE_PARALLEL 3→6, FENSTER 8→12,
         ENTPACK_PARALLEL 2→3 am Handy (13,0 statt 12,7). Der Engpass ist also
         weder Bytes noch Parallelität noch das Kartenfenster. Achtung beim
         Weitersuchen: `leer` zählt TAKTE, und die Zahl der Takte unterscheidet
         sich je Gerät — Werte nur INNERHALB eines Geräts vergleichen. */
      if (mobil) return;
      var c = navigator.connection;
      if (c && (c.saveData || /2g/.test(c.effectiveType || ''))) return;
      grobGestartet = true;
      var q = [];
      for (var g = 0; g < anzahl; g += GROB) if (!dateien[g] && !unterwegs[g]) q.push(g);
      ladeSchlange = ladeSchlange.concat(q);
      ladeNaechste();
    }
    /* Start kurz nach dem Aufbau, NICHT erst nach `load`: gemessen lag `load` bei
       2,4 s (13 Apps) — wer vorher scrollt, fand sonst wieder nichts vor. Solange
       die Seite lädt, holt der Lader ohnehin nur 2 Bilder gleichzeitig (ladeGrenze). */
    setTimeout(grobVorladen, 300);

    /* 29.09.2026: Anlauf am Handy, nur wenn der Film nah oben steht (siehe Vorlauf-Beobachter): Bild 0–24 und
       jedes 8. Bild — ≈ 39 Bilder ≈ 2 MB statt der ganzen Reihe (133 Bilder, 5,8 MB) ohne Scrollen. Läuft wie der
       Grobsatz über denselben Lader (grobGestartet hält `dringend` davon ab, die Schlange wegzuwerfen). */
    var ANLAUF = 24;
    function anlaufVorladen() {
      if (grobGestartet || vorladenGestartet || !film) return;
      var c = navigator.connection;
      if (c && (c.saveData || /2g/.test(c.effectiveType || ''))) return;
      grobGestartet = true;
      var q = [];
      for (var i = 0; i < anzahl; i++) if ((i <= ANLAUF || i % GROB === 0) && !dateien[i] && !unterwegs[i]) q.push(i);
      ladeSchlange = ladeSchlange.concat(q);
      ladeNaechste();
    }

    /* Wird gerade ein Bild gebraucht, das noch nicht da ist: nach vorn */
    function dringend(i) {
      if (dateien[i] || unterwegs[i]) return;
      var k = ladeSchlange.indexOf(i);
      if (k > 0) { ladeSchlange.splice(k, 1); ladeSchlange.unshift(i); }
      else if (k === -1) ladeSchlange.unshift(i);
      /* Solange die Sperre zu ist: NUR dieses eine Bild holen. Vorher rief
         `dringend` das volle `vorladen()`, und das setzt `ladeSchlange` auf
         die komplette Reihenfolge — ein einziges gebrauchtes Bild zog damit
         alle 217 hinter sich her. */
      if (!vorladenGestartet) {
        /* R542: läuft der Grobsatz, steht `i` schon vorn in der Schlange — nicht wegwerfen */
        if (!hatGescrollt) { if (!grobGestartet) ladeSchlange = [i]; ladeNaechste(); return; }
        vorladen(true);
      } else ladeNaechste();
    }

    /* ---------- 2. Entpacken: nur ein Fenster, abseits des Hauptfadens ---------- */
    var karten = {};        // idx → ImageBitmap | 'wartet' | 'laeuft'
    var kartenSchlange = [];
    var kartenLaufend = 0;
    var mitte = 0;

    function karteAnfordern(i) {
      if (karten[i]) return;
      if (!dateien[i]) { dringend(i); return; }
      karten[i] = 'wartet';
      kartenSchlange.push(i);
      karteAnlegen();
    }

    function karteAnlegen() {
      while (kartenLaufend < ENTPACK_PARALLEL && kartenSchlange.length) {
        var i = kartenSchlange.shift();
        if (karten[i] !== 'wartet') continue;
        if (Math.abs(i - mitte) > FENSTER * 2) { delete karten[i]; continue; }
        karten[i] = 'laeuft';
        kartenLaufend++;
        (function (i) {
          createImageBitmap(dateien[i]).then(function (bm) {
            kartenLaufend--;
            if (Math.abs(i - mitte) > FENSTER * 2) { bm.close(); delete karten[i]; }
            else { karten[i] = bm; if (sichtbar) takt(true); }
            karteAnlegen();
          }, function () { kartenLaufend--; delete karten[i]; karteAnlegen(); });
        })(i);
      }
    }

    function aufraeumen(m) {
      Object.keys(karten).forEach(function (k) {
        var i = +k, v = karten[i];
        var weg = Math.abs(i - m) > FENSTER * 2 || (leicht && i % schritt);
        if (weg && v !== 'laeuft') {
          if (v && typeof v === 'object') v.close();
          delete karten[i];
        }
      });
    }

    /* R512: Beim Spulen zuerst die Bilder IN Scrollrichtung entpacken; hinter
       der Stelle nur ein halbes Fenster. Die Warteschlange wird jedes Mal neu
       geordnet — sonst warteten veraltete Aufträge vor den gebrauchten. */
    var richtung = 1;
    function fensterPflegen(m) {
      if (m !== mitte) richtung = m > mitte ? 1 : -1;
      mitte = m;
      kartenSchlange.forEach(function (i) { if (karten[i] === 'wartet') delete karten[i]; });
      kartenSchlange = [];
      var halb = Math.ceil(FENSTER / 2);
      for (var d = 0; d <= FENSTER; d += schritt) {
        var vor = m + richtung * d, zurueck = m - richtung * d;
        if (vor >= 0 && vor < anzahl) karteAnfordern(vor);
        if (d && d <= halb && zurueck >= 0 && zurueck < anzahl) karteAnfordern(zurueck);
      }
      aufraeumen(m);
    }
    /* Aus dem Bild: entpackte Bilder freigeben (je ~4,7 MB bei 1440 px) */
    function freigeben() {
      kartenSchlange = [];
      Object.keys(karten).forEach(function (k) {
        var i = +k, v = karten[i];
        if (v === 'laeuft') return;
        if (Math.abs(i - mitte) <= 1) return;
        if (v && typeof v === 'object') v.close();
        delete karten[i];
      });
    }

    function karte(i) {
      var k = karten[i];
      return (k && typeof k === 'object') ? k : null;
    }
    function naechsteKarte(ziel) {
      if (karte(ziel)) return ziel;
      for (var d = 1; d < anzahl; d++) {
        if (ziel - d >= 0 && karte(ziel - d)) return ziel - d;
        if (ziel + d < anzahl && karte(ziel + d)) return ziel + d;
      }
      return -1;
    }

    /* ---------- 3. Zeichnen: nur im Bild ---------- */
    var p = 0;
    var aktiv = -1;
    var breite = 0, hoehe = 0;
    var zuletzt = '';
    var sichtbar = false;

    function messen() {
      var r = canvas.getBoundingClientRect();
      breite = Math.max(1, Math.round(r.width));
      hoehe = Math.max(1, Math.round(r.height));
      /* dpr 1: die Quelle hat 1440 px — mehr Canvas-Pixel kosten nur.
         29.09.2026: nur bei echter Größenänderung zuweisen — jede Zuweisung leert die Leinwand, und Safari feuert
         resize bei jedem Ein-/Ausklappen der Adressleiste, also mitten im Scrollen (Fund der Werkstatt). */
      if (canvas.width !== breite || canvas.height !== hoehe) {
        canvas.width = breite;
        canvas.height = hoehe;
        zuletzt = '';
      }
    }

    function malen(bm, alpha) {
      var s = Math.max(breite / bm.width, hoehe / bm.height);
      var w = bm.width * s, h = bm.height * s;
      ctx.globalAlpha = alpha;
      ctx.drawImage(bm, (breite - w) / 2, (hoehe - h) / 2, w, h);
      ctx.globalAlpha = 1;
    }

    var steht = false, ruheUhr = null, letztesP = -1;
    function einrasten() { steht = true; zuletzt = ''; takt(true); }
    function zeichnen() {
      if (!film || !sichtbar || !breite) return;
      var f = p * (anzahl - 1);
      var a = Math.floor(f / schritt) * schritt;
      var b = Math.min(anzahl - 1, a + schritt);
      var t = (f - a) / schritt;
      if (a !== mitte) fensterPflegen(a);
      var ia = karte(a) ? a : -1, ib = karte(b) ? b : -1;
      if (ia < 0 || ib < 0 || leicht) {
        ia = naechsteKarte(Math.round(f / schritt) * schritt);
        ib = -1; t = 0;
      }
      /* R512: Steht der Scroll, auf das nächste ECHTE Bild einrasten — eine
         halbe Überblendung zweier ungleicher Bilder bleibt sonst als
         Doppelbild stehen (gemessen am Drohnenflug bei 85 %). */
      if (p !== letztesP) { letztesP = p; steht = false; clearTimeout(ruheUhr); ruheUhr = setTimeout(einrasten, 180); }
      if (steht && ib >= 0) { if (t >= 0.5) ia = ib; ib = -1; t = 0; }
      if (ia < 0) { var mwl = messwert('weg'); mwl.leer = (mwl.leer || 0) + 1; return; }       // noch nichts entpackt: das Standbild im CSS steht
      var stufe = Math.round(t * 16);
      var schluessel = ia + '|' + ib + '|' + stufe + '|' + breite + 'x' + hoehe;
      if (schluessel === zuletzt) return;
      zuletzt = schluessel;
      /* R512: Messpunkt — wie oft fehlte das gewünschte Bild (Ersatz = nächstes
         entpacktes Bild bzw. keine Überblendung)? Kostet eine Addition. */
      var mw = messwert('weg'); mw.gemalt++;
      /* R542: wie WEIT lag das Ersatzbild daneben? „Ersatz" allein zählt einen
         Nachbarn genauso wie Bild 0 statt Bild 80 — das eine sieht man nicht, das andere springt. */
      var weit = Math.abs(ia - a); mw.abstand = (mw.abstand || 0) + weit; if (weit > (mw.maxAbstand || 0)) mw.maxAbstand = weit;
      if (!leicht && (ia !== a || (ib < 0 && t > 0.06))) {
        mw.ersatz++;
        var fehlt = ia !== a ? a : b;
        if (!dateien[fehlt]) mw.ohneDatei = (mw.ohneDatei || 0) + 1; else mw.ohneKarte = (mw.ohneKarte || 0) + 1;
      }
      malen(karten[ia], 1);
      if (ib >= 0 && stufe > 0) malen(karten[ib], stufe / 16);
      if (!wurzel.classList.contains('is-film')) wurzel.classList.add('is-film');
    }

    function flugAnteil(t) {
      var von = 3 / N, bis = 4 / N;   // die Flug-Station
      var f = Math.max(0, Math.min(1, (t - von) / Math.max(0.001, bis - von)));
      return f * f * (3 - 2 * f);
    }
    function kilometer(t) { return Math.round(flugAnteil(t) * GESAMT_KM); }
    function karteSetzen(t) {
      if (!kartenBogen) return;
      var f = Math.round(flugAnteil(t) * 200) / 200;
      if (f === flugZuletzt) return;            // nur bei Änderung schreiben
      flugZuletzt = f;
      /* direkt am Pfad, nicht als Variable an der Sektion: so wird nur
         dieser eine Pfad neu gezeichnet, nicht der ganze Abschnitt */
      kartenBogen.style.strokeDashoffset = String(1 - f);
      if (kartenPunkt && bogenLaenge) {
        var pt = kartenBogen.getPointAtLength(f * bogenLaenge);
        kartenPunkt.setAttribute('cx', pt.x.toFixed(1));
        kartenPunkt.setAttribute('cy', pt.y.toFixed(1));
      }
    }

    function standSetzen() {
      var idx = Math.max(0, Math.min(N - 1, Math.floor(p * N)));
      if (idx !== aktiv) {
        aktiv = idx;
        stationen.forEach(function (st, i) { st.classList.toggle('is-an', i === idx); });
        marken.forEach(function (m, i) { m.classList.toggle('is-an', i <= idx); });
        if (anzeigeNr) anzeigeNr.textContent = String(idx + 1).padStart(2, '0');
        if (anzeigeOrt) anzeigeOrt.textContent = stationen[idx].getAttribute('data-usp-weg-ort') || '';
      }
      /* Text nur schreiben, wenn er sich ändert: jede Textänderung macht das
         Layout ungültig, und das nächste Skript, das etwas liest, zahlt die
         komplette Neuvermessung der Seite (R508). */
      var km = kilometer(p);
      if (anzeigeKm && km !== kmZuletzt) { kmZuletzt = km; anzeigeKm.textContent = km.toLocaleString('de-DE'); }
      if (bahn) bahn.style.transform = 'scaleX(' + p.toFixed(4) + ')';
      karteSetzen(p);
      wurzel.classList.toggle('is-start', p < 0.03);
    }

    /* ---------- 4. Eigene Messung: hakt es beim Spulen? ---------- */
    var zuletztTakt = 0, takte = 0, langeTakte = 0, kmZuletzt = -1;
    /* Erst messen, wenn die Seite fertig geladen ist: vorher ruckelt JEDES
       Gerät (gemessen: auf dem M4 schaltete die Messung beim Laden fälschlich
       auf „leicht", weil fremde Skripte die Takte verlängerten). */
    var messbar = false;
    window.addEventListener('load', function () { setTimeout(function () { messbar = true; }, 3000); }, { once: true });
    if (document.readyState === 'complete') setTimeout(function () { messbar = true; }, 3000);
    /* 29.09.2026 (Marcel: „laggt noch leicht“): Bisher zählte hier der Abstand zwischen zwei SCROLL-Ereignissen.
       Mit dem Mausrad (Rasten alle 60–120 ms) war jede Raste ein „langer Takt“, obwohl kein Bild ruckelte (gemessen
       1920: 0 Bilder > 20 ms) — nach 90 Takten schaltete der Film auf die leichte Fassung (jedes 2. Bild, ohne
       Überblendung) und ruckelte erst dadurch. Jetzt läuft beim Scrollen (und 300 ms danach) eine eigene rAF-Kette
       und misst die echten Bildabstände; Pausen zwischen Rasten zählen nicht mehr. */
    var messLauf = false, messBis = 0;
    function messRahmen(jetzt) {
      if (zuletztTakt) {
        var dt = jetzt - zuletztTakt;
        if (dt < 250) {
          takte++;
          if (dt > 40) langeTakte++;
          if (takte >= 90) {
            /* Mehr als ein Viertel langer Bilder beim Spulen → leichte Fassung */
            if (langeTakte / takte > 0.25) leichtSchalten();
            takte = 0; langeTakte = 0;
          }
        }
      }
      zuletztTakt = jetzt;
      if (!leicht && performance.now() < messBis) requestAnimationFrame(messRahmen);
      else { messLauf = false; zuletztTakt = 0; }
    }
    function taktMessen() {
      if (leicht || !messbar) return;
      messBis = performance.now() + 300;
      if (!messLauf) { messLauf = true; zuletztTakt = 0; requestAnimationFrame(messRahmen); }
    }

    var angefordert = false;
    function takt(nurBild) {
      if (!sichtbar || angefordert) return;
      angefordert = true;
      requestAnimationFrame(function (jetzt) {
        angefordert = false;
        var r = wurzel.getBoundingClientRect();
        var weg = r.height - window.innerHeight;
        p = weg <= 0 ? 0 : Math.max(0, Math.min(1, -r.top / weg));
        if (nurBild !== true) { standSetzen(); taktMessen(jetzt); }
        zeichnen();
      });
    }

    /* Der echte Scroller ist ab 990 px `.page-wrapper`, nicht das Fenster. */
    var ziel = (window.innerWidth >= 990 && document.querySelector('.page-wrapper')) || document;
    ziel.addEventListener('scroll', function () { takt(); }, { passive: true });
    ziel.addEventListener('scroll', beiBewegung, { passive: true });
    window.addEventListener('scroll', beiBewegung, { passive: true });
    window.addEventListener('resize', function () { messen(); takt(); }, { passive: true });

    /* Sichtbarkeit: MIT dem echten Scroller als root (sonst misst der
       Beobachter gegen das Fenster und die Sektion ist bis zuletzt
       „abgeschnitten" — R503). */
    var root = ziel === document ? null : ziel;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          var war = sichtbar;
          sichtbar = e.isIntersecting;
          if (sichtbar && !war) { if (!breite) messen(); zuletzt = ''; vorladen(); takt(); }
          else if (!sichtbar && war) freigeben();
        });
      }, { root: root, rootMargin: '10% 0px 10% 0px' }).observe(wurzel);
      /* Früher Vorlauf: 2 Bildschirme vor der Sektion mit dem Vorladen beginnen */
      var vorlauf = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          vorlauf.disconnect();
          /* 29.09.2026 (Marcel: „laggt noch leicht“, Fund der Werkstatt): Steht der Film am Handy schon beim Laden im
             ersten 1,5-fachen Bildschirm (Weiterleitungsseite: 741 px tief), kam bis zum ersten Scrollen nur 1 Bild
             (keinen Grobsatz am Handy, R542), und der Film blieb beim Losscrollen leer (iPhone leer 9–10 + Ersatz 13–16,
             Android leer 24–25). Dann ohne Scrollen den ANLAUF holen und schon entpacken; die volle Reihe wartet
             weiter auf Scrollweg (R539). Startseite: Film viele Bildschirme tief → hier nie „nah oben“. */
          var nahOben = mobil && standRoll() < STRECKE && e.boundingClientRect.top < window.innerHeight * 1.5;
          if (nahOben) { vorEntpacken = true; anlaufVorladen(); }
          vorladen();
        });
      }, { root: root, rootMargin: '200% 0px 200% 0px' });
      vorlauf.observe(wurzel);
    } else {
      sichtbar = true;
    }

    /* Sonst: nach dem Laden der Seite im Leerlauf — nie während sie lädt */
    // 29.09.: requestIdleCallback übergibt ein IdleDeadline-Objekt — direkt übergeben las vorladen() es als sofort = wahr und
    // umging die Scroll-Sperre (R539): Chrome/Android luden ohne Scrollen die Filmbilder. Deshalb ohne Argument aufrufen.
    function nachDemLaden() { setTimeout(function () { leerlauf(function () { vorladen(); }, { timeout: 1000 }); }, 300); }
    if (document.readyState === 'complete') nachDemLaden();
    else window.addEventListener('load', nachDemLaden, { once: true });

    /* Leinwand kann ihren Inhalt verlieren (Chrome gibt 2D-Leinwände im
       Hintergrund bei Speicherdruck frei) → bei Rückkehr neu zeichnen. */
    function neuZeichnen() { zuletzt = ''; takt(); }
    canvas.addEventListener('contextrestored', neuZeichnen);
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') neuZeichnen();
    });
    window.addEventListener('pageshow', neuZeichnen);

    /* Nur EIN Zähler: Solange der Film die Bildmitte füllt, tritt die
       Diagnose-Schiene zurück (CSS in usp-weg.css). */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          document.documentElement.classList.toggle('usp-weg-im-bild', e.isIntersecting);
          /* Die Diagnose-Schiene rechnet während des Films nicht. Beim
             Verlassen einmal anstoßen, sonst stünde sie bis zum nächsten
             Scrollschritt noch auf „Der Weg". */
          if (!e.isIntersecting) ziel.dispatchEvent(new Event('scroll'));
        });
      }, { root: root, rootMargin: '-45% 0px -45% 0px' }).observe(wurzel);
    }

    /* Leistungswache (usp-motion.js): „mittel" → leichte Fassung,
       „sparsam" → keine Folge, nur das Standbild aus dem CSS. */
    function wache(stufe) {
      if (stufe === 'sparsam') {
        film = false;
        ladeSchlange = [];
        wurzel.classList.remove('is-film');
        wurzel.classList.add('is-ruhig');
      } else if (stufe === 'mittel') {
        leichtSchalten();
      }
    }
    if (window.uspMotion) {
      wache(window.uspMotion.stufe);
      window.uspMotion.beiStufe(wache);
    }

    messen();
  }
})();
